import { render } from "./RadioButtons.vue?vue&type=template&id=49e163f1"
import script from "./RadioButtons.vue?vue&type=script&lang=js"
export * from "./RadioButtons.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/RadioButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "49e163f1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('49e163f1', __exports__)) {
    console.log('reload')
    api.reload('49e163f1', __exports__)
  }
  
  module.hot.accept("./RadioButtons.vue?vue&type=template&id=49e163f1", () => {
    console.log('re-render')
    api.rerender('49e163f1', render)
  })

}


export default __exports__